"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  id: 306,
  firstName: 'Ariel',
  middleName: 'Ricardo',
  lastName: 'Erviti',
  email: 'ariel.erviti.ae@gmail.com',
  uploadPhotoScreenShowed: true,
  photoUrl: '',
  thumb_url: '',
  myselfEmoji: "\uD83E\uDDD2\uD83D\uDC67\uD83D\uDC74\uD83D\uDC74\uD83D\uDE0C",
  yearGraduation: '2021',
  monthGraduation: '6',
  workElegibility: {
    authorized: 1,
    sponsorship: 1,
    work: 1
  },
  includeWorkEligibilityResume: false,
  heardFromUs: null,
  heardFromUsSubOption: null,
  heardFromUsExpanded: '',
  typeName: 'Recent Graduate',
  typeId: '5',
  pronouns: {
    subject: '',
    object: 'he',
    possessive: 'c'
  },
  internationalHome: 0,
  cityOfHome: '2',
  countryCityOfHome: '',
  cityOfHomeName: 'Abbeville',
  countryOfHome: '2',
  countryOfHomeName: 'Algeria',
  cityOfUniversity: '140',
  cityOfUniversityName: 'Advance',
  stateOfHome: 'AL',
  stateOfHomeName: 'Alabama',
  stateOfUniversity: 'MO',
  stateOfUniversityName: 'Missouri',
  university: '22',
  universityName: 'Albion College',
  phone: '2423932844',
  receiveUpdates: 0,
  street: null,
  zipCode: '',
  specialization: '1',
  hasMinors: '1',
  minors: [{
    minor: '1',
    otherMinor: '',
    minorName: 'Accounting',
    category: 1,
    otherCategory: '',
    categoryName: 'Accounting',
    minorConcentration: '9',
    minorSecondConcentration: '8'
  }],
  gpa: '10',
  notPublishGPAS: '',
  notHaveGPA: '',
  includeGPAOnResume: true,
  includeAdditionalDiversityResume: false,
  includeDiversityInclusionsResume: false,
  hasScholarships: '1',
  scholarships: [{
    name: 'scholarship 1',
    amount: '10000',
    includeOnResume: 1,
    fullTuition: 0
  }, {
    name: 'Name',
    amount: '',
    includeOnResume: 0,
    fullTuition: 0
  }],
  hasHonors: '1',
  honors: [{
    name: 'Honor 1',
    isThroughoutCollege: true,
    year: [2010, 2012, 2014],
    includeOnResume: true
  }, {
    name: 'Honor 2',
    isThroughoutCollege: false,
    year: [2010, 2014, 2018],
    includeOnResume: false
  }],
  hasStudiesAbroad: '1',
  studiesAbroad: [{
    city: 'Cordoba',
    cityName: 'Cordoba',
    country: '4',
    countryName: 'Argentina',
    name: 'University 1',
    periodOfStudy: '3',
    periodOfStudyName: 'Summer',
    program: 'program 1',
    year: '2012',
    includeOnResume: true
  }, {
    city: 'Buenos Aires',
    cityName: 'Buenos Aires',
    country: '4',
    countryName: 'Argentina',
    name: 'University 2',
    periodOfStudy: '1',
    periodOfStudyName: 'Fall',
    program: 'Program 2',
    year: '2013',
    includeOnResume: false
  }],
  internationalHighSchool: 0,
  highSchoolName: 'ads',
  highSchoolCity: '537',
  highSchoolCityName: 'Amado',
  highSchoolCountryCity: '537',
  highSchoolCountry: '',
  highSchoolCountryName: null,
  highSchoolState: 'AZ',
  highSchoolStateName: 'Arizona',
  highSchoolMonthGraduation: '2',
  highSchoolYearGraduation: '2014',
  includeHighSchoolOnResume: true,
  includeHighSchoolHonorsOnResume: true,
  includeActSatScoreOnResume: true,
  highSchoolHonors: [{
    name: 'High school honor 1',
    year: '2012',
    includeOnResume: true
  }, {
    name: 'High school honor 2',
    year: '2012',
    includeOnResume: false
  }],
  satScore: '12',
  actScore: '11',
  hasEnhancedAcademicExperiences: '1',
  enhancedAcademicExperiences: [{
    id: 20796,
    city: '10160',
    cityName: 'Gilmanton Iron Works',
    countryCity: '',
    international: 0,
    country: '',
    countryName: null,
    state: 'NH',
    stateName: 'New Hampshire',
    periodOfStudy: '3',
    periodOfStudyName: 'Summer',
    program: 'Enhanced Academic Exp 2 E',
    year: 2014,
    activeLines: null,
    isThroughoutCollege: true,
    includeOnResume: true,
    lines: [{
      high: 0,
      maxLength: 109,
      selected: 0,
      isMerge: 0,
      isHighlighted: 0,
      value: 'a',
      chosen: 0,
      enabled: 1,
      id: 'FHGDxPbLf'
    }, {
      high: 0,
      maxLength: 109,
      selected: 0,
      isMerge: 0,
      isHighlighted: 0,
      value: 'a',
      chosen: 0,
      enabled: 1,
      id: 'FHGDxPbLf'
    }]
  }],
  hasDivisionAthletics: '2',
  d1Athletics: [],
  technicalSkill: [{
    proficiency: '4',
    proficiencyName: 'Expert',
    name: 'Javascript',
    added: 1,
    includeOnResume: true
  }, {
    proficiency: '4',
    proficiencyName: 'Expert',
    name: 'NodeJs',
    added: 1
  }, {
    proficiency: '5',
    proficiencyName: 'Advanced',
    name: 'MongoDB',
    added: 1
  }, {
    proficiency: '4',
    proficiencyName: 'Expert',
    name: 'ReactJS',
    added: 1
  }, {
    proficiency: '5',
    proficiencyName: 'Advanced',
    name: 'React Native',
    added: 1
  }],
  languages: [{
    proficiency: '6',
    proficiencyName: 'Native',
    language: 118,
    languageName: 'Spanish',
    added: 1
  }, {
    proficiency: '1',
    proficiencyName: 'Proficient',
    language: 38,
    languageName: 'English',
    added: 1,
    includeOnResume: true
  }],
  personalInterests: [{
    name: 'Games',
    added: 1,
    includeOnResume: true
  }, {
    name: 'Tech',
    added: 1
  }, {
    name: 'Programming',
    added: 1
  }],
  certificationsAndLicences: [{
    name: 'one.',
    added: 1,
    includeOnResume: true
  }, {
    name: 'two..',
    added: 1
  }],
  amountProfessionalExperiences: 7,
  amountOtherExperiences: 4,
  professionalExperiences: [{
    id: 45438,
    company: 'Other Experience',
    industry: '3',
    position: 'asd',
    state: 'AK',
    stateName: 'Alaska',
    city: '78',
    cityName: 'Adak',
    countryCity: '',
    international: 0,
    country: '',
    countryName: null,
    startYear: '2011',
    endYear: '2011',
    startMonth: '2',
    endMonth: '1',
    positionFunction: '3',
    switch: 1,
    activeLines: 1,
    isHighlighted: null,
    lines: [{
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 1,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 1,
      id: 'Vxy2L7FCd'
    }, {
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 1,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 1,
      id: 'bHbRKTy5mT'
    }]
  }, {
    id: 45439,
    company: 'LINEA 9',
    industry: '2',
    position: 'sdgsdg',
    state: 'AK',
    stateName: 'Alaska',
    city: '193',
    cityName: 'Akiachak',
    countryCity: '',
    international: 0,
    country: '',
    countryName: null,
    startYear: '2011',
    endYear: '2012',
    startMonth: '2',
    endMonth: '1',
    positionFunction: '4',
    switch: 1,
    activeLines: 0,
    isHighlighted: null,
    lines: [{
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 0,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 0,
      id: 'PsdFHk3ssR'
    }, {
      high: 0,
      maxLength: 109,
      selected: 0,
      isMerge: 0,
      isHighlighted: 0,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 0,
      id: 'QcoSRUD9I6'
    }]
  }, {
    id: 45440,
    company: 'Flydevs',
    industry: '16',
    position: 'Senior development',
    state: 'AL',
    stateName: 'Alabama',
    city: 'Buenos Aires',
    cityName: null,
    countryCity: 'Buenos Aires',
    international: 1,
    country: '4',
    countryName: 'Argentina',
    startYear: '2016',
    endYear: '2018',
    startMonth: '7',
    endMonth: '1',
    positionFunction: '18',
    switch: 1,
    activeLines: 1,
    isHighlighted: null,
    lines: [{
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 1,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 1,
      id: '1TkjrbH4nJ'
    }, {
      high: 0,
      maxLength: 109,
      selected: null,
      isMerge: 0,
      isHighlighted: 1,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 1,
      id: '6Vv_9UefTQ'
    }]
  }, {
    id: 45441,
    company: 'LINEA 3',
    industry: '1',
    position: 'asffsgadsg',
    state: 'AL',
    stateName: 'Alabama',
    city: '2',
    cityName: 'Abbeville',
    countryCity: '',
    international: 0,
    country: '',
    countryName: null,
    startYear: '2011',
    endYear: '2013',
    startMonth: '1',
    endMonth: '2',
    positionFunction: '3',
    switch: 1,
    activeLines: 0,
    isHighlighted: null,
    lines: [{
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 0,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 0,
      id: '97G5foWR-J'
    }, {
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 1,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 0,
      id: '1pqKVpDTsB'
    }]
  }, {
    id: 45442,
    company: 'LINEA 6',
    industry: '6',
    position: 'dasgasdg a',
    state: 'AL',
    stateName: 'Alabama',
    city: '2',
    cityName: 'Abbeville',
    countryCity: '',
    international: 0,
    country: '',
    countryName: null,
    startYear: '2011',
    endYear: '2011',
    startMonth: '1',
    endMonth: '1',
    positionFunction: '3',
    switch: 1,
    activeLines: 0,
    isHighlighted: null,
    lines: [{
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 0,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 0,
      id: 'F3GnkpZs1Z'
    }, {
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 0,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 0,
      id: 'pIBDAMzoF_'
    }]
  }, {
    id: 45443,
    company: 'LINEA 11',
    industry: '3',
    position: 'sdgsdg',
    state: 'AL',
    stateName: 'Alabama',
    city: '23',
    cityName: 'Abernant',
    countryCity: '',
    international: 0,
    country: '',
    countryName: null,
    startYear: '2011',
    endYear: '2012',
    startMonth: '2',
    endMonth: '1',
    positionFunction: '2',
    switch: 1,
    activeLines: 0,
    isHighlighted: null,
    lines: [{
      high: 0,
      maxLength: 109,
      selected: 0,
      isMerge: 0,
      isHighlighted: 0,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 0,
      id: 'TXqlb00mWJ'
    }, {
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 0,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 0,
      id: 'fAOHVWlX3P'
    }, {
      high: 0,
      maxLength: 109,
      selected: 0,
      isMerge: 0,
      isHighlighted: 0,
      value: 'Lorem ipsum dolor sit amet consectetuer',
      chosen: 0,
      enabled: 0,
      id: '4z6GIZU9KK'
    }]
  }, {
    id: 45444,
    company: 'LINEA 5',
    industry: '3',
    position: 'dasgadg',
    state: 'AR',
    stateName: 'Arkansas',
    city: '304',
    cityName: 'Alexander',
    countryCity: '',
    international: 0,
    country: '',
    countryName: null,
    startYear: '2012',
    endYear: '2012',
    startMonth: '2',
    endMonth: '2',
    positionFunction: '3',
    switch: 1,
    activeLines: 0,
    isHighlighted: null,
    lines: [{
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 1,
      value: 'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit...',
      chosen: 0,
      enabled: 0,
      id: 'WeodPEtWz1'
    }, {
      high: 1,
      maxLength: 218,
      selected: 0,
      isMerge: 1,
      isHighlighted: 0,
      value: 'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit...',
      chosen: 0,
      enabled: 0,
      id: 'f9F0SF7M7x'
    }]
  }],
  otherExperiences: [{
    id: 43243,
    group: 'LINEA 4',
    position: 'adgdagagag',
    startYear: '2012',
    endYear: '2012',
    startMonth: '3',
    endMonth: '3',
    city: '194',
    countryCity: '',
    international: 0,
    cityName: 'Akiak',
    country: '',
    countryName: null,
    state: 'AK',
    stateName: 'Alaska',
    switch: 0,
    activeLines: 1,
    organizationalCategories: ['Career', 'Athletics'],
    isHighlighted: null,
    lines: [{
      high: 0,
      maxLength: 109,
      selected: 0,
      isMerge: 0,
      isHighlighted: 0,
      value: 'Lorem ipsum dolor sit amet',
      chosen: 0,
      enabled: 1,
      id: 'BWxPp76R-E'
    }]
  }, {
    id: 43244,
    group: 'LINEA 2',
    position: 'asdf',
    startYear: '2011',
    endYear: '2011',
    startMonth: '1',
    endMonth: '1',
    city: '2',
    countryCity: '',
    international: 0,
    cityName: 'Abbeville',
    country: '',
    countryName: null,
    state: 'AL',
    stateName: 'Alabama',
    switch: 0,
    activeLines: 0,
    organizationalCategories: ['Career', 'Community', 'Athletics'],
    isHighlighted: null,
    lines: [{
      high: 0,
      maxLength: 109,
      selected: 0,
      isMerge: 0,
      isHighlighted: 0,
      value: 'asdg',
      chosen: 0,
      enabled: 0,
      id: '7_0Nt50SWS7'
    }]
  }, {
    id: 43245,
    group: 'LINEA 7',
    position: 'adgadgdag',
    startYear: '2012',
    endYear: '2011',
    startMonth: '3',
    endMonth: '2',
    city: '2',
    countryCity: '',
    international: 0,
    cityName: 'Abbeville',
    country: '',
    countryName: null,
    state: 'AL',
    stateName: 'Alabama',
    switch: 0,
    activeLines: 0,
    organizationalCategories: ['Diversity', 'Athletics', 'Academic', 'dasgdas'],
    isHighlighted: null,
    lines: [{
      high: 0,
      maxLength: 109,
      selected: 0,
      isMerge: 0,
      isHighlighted: 0,
      value: 'sgdsdgg',
      chosen: 0,
      enabled: 0,
      id: '7ZyEWSs_OT-'
    }]
  }, {
    id: 43246,
    group: 'LINEA 10',
    position: 'adgdg',
    startYear: '2011',
    endYear: '2011',
    startMonth: '1',
    endMonth: '2',
    city: '23',
    countryCity: '',
    international: 0,
    cityName: 'Abernant',
    country: '',
    countryName: null,
    state: 'AL',
    stateName: 'Alabama',
    switch: 0,
    activeLines: 0,
    organizationalCategories: ['Career', 'Community', 'Academic'],
    isHighlighted: null,
    lines: [{
      high: 0,
      maxLength: 109,
      selected: 0,
      isMerge: 0,
      isHighlighted: 0,
      value: 'dfhdh',
      chosen: 0,
      enabled: 0,
      id: '-rIW1Ph8c7e'
    }]
  }],
  diversity: [{
    category: '10',
    categoryName: 'Other',
    status: null,
    statusName: null,
    otherStatus: 'other',
    added: 1,
    includeOnResume: true
  }, {
    category: '10',
    categoryName: 'Other',
    status: null,
    statusName: null,
    otherStatus: 'other',
    added: 1,
    includeOnResume: false
  }],
  additionalInformation: [{
    name: 'Eligible Pell Grant Recipient'
  }],
  linkedInURL: 'arielerv',
  alternativeEmail: 'ariel.erviti.ae@gmail.com',
  links: [{
    url: 'Link1',
    title: 'El titulo del link1',
    added: 1
  }, {
    url: 'asd',
    title: 'asd',
    added: 1
  }],
  coursework: [{
    course: 'React',
    added: 1,
    majorName: 'Advertising'
  }, {
    course: 'Node',
    added: 1,
    includeOnResume: 1
  }, {
    course: 'asd',
    added: 1,
    majorName: null
  }, {
    course: 'test',
    added: 1,
    majorName: ''
  }, {
    course: 'test2',
    added: 1,
    majorName: '',
    major: '385',
    otherMajor: 'test2'
  }, {
    course: 'test3',
    added: 1,
    majorName: '',
    major: '385',
    otherMajor: ''
  }, {
    course: 'test4',
    added: 1,
    majorName: '',
    major: '385',
    otherMajor: null
  }],
  hasRelevantCourseWorks: '1',
  includeRelevantCourseWorksOnResume: true,
  relevantCourseWorks: [{
    course: 'coursework 1',
    added: 1
  }],
  industries: [{
    industry: '2',
    industryName: 'Agriculture & Natural Resources',
    subIndustry: '292',
    subIndustryName: 'Farming',
    added: 1
  }, {
    industry: '14',
    industryName: 'Hospitality, Tourism & Travel',
    subIndustry: '415',
    subIndustryName: 'Airlines',
    added: 1
  }, {
    industry: '27',
    industryName: 'Transportation, Distribution & Logistics',
    subIndustry: '511',
    subIndustryName: 'Railroads',
    added: 1
  }],
  jobsInterest: [{
    job: '6',
    jobName: 'Business Development',
    added: 1
  }, {
    job: '2',
    jobName: 'Administrative',
    added: 1
  }],
  careers: [{
    career: '10',
    careerName: 'Career Development',
    added: 1
  }, {
    career: '3',
    careerName: 'Achievement',
    added: 1
  }],
  seeking: 0,
  preferences: [],
  firstConcentration: '1',
  secondConcentration: '1',
  hasConcentrations: '2',
  hasDiversity: '1',
  lasLevelCompleted: 'PC',
  hasResumeLevelsComplete: true,
  typeSeeking: '2',
  hasSeekingFirstJob: '2',
  firstCollege: 'college optional',
  firstDegree: '7',
  firstDegreeName: 'Bachelor of Design',
  firstMajor: '2',
  firstMajorName: 'Actuarial Science',
  firstMajorCategory: 10,
  firstMajorCategoryName: 'Economics, Finance, Math & Statistics',
  graduationMonth: '6',
  graduationYear: '2021',
  firstMajorGPA: '8',
  includeFirstMajorGPAOnResume: true,
  firstMajorConcentration: '7',
  firstMajorSecondConcentration: '8',
  firstDegreeConcentration: null,
  firstDegreeSecondConcentration: null,
  otherFirstDegree: null,
  otherFirstMajor: null,
  otherFirstMajorCategory: null,
  secondCollege: null,
  secondDegree: null,
  secondDegreeName: null,
  secondMajor: null,
  secondMajorName: null,
  secondMajorCategory: null,
  secondMajorCategoryName: null,
  secondMajorMonth: null,
  secondMajorYear: null,
  secondMajorGPA: null,
  includeSecondMajorGPAOnResume: false,
  secondMajorConcentration: null,
  secondMajorSecondConcentration: null,
  secondDegreeConcentration: null,
  secondDegreeSecondConcentration: null,
  otherSecondDegree: null,
  otherSecondMajor: null,
  otherSecondMajorCategory: null,
  thirdMajor: null,
  thirdMajorName: null,
  thirdMajorCategory: null,
  thirdMajorCategoryName: null,
  thirdMajorGPA: null,
  includeThirdMajorGPAOnResume: false,
  thirdMajorConcentration: null,
  thirdMajorSecondConcentration: null,
  otherThirdMajor: null,
  otherThirdMajorDegree: null,
  otherThirdMajorCategory: null,
  bePreparedAnswers: {
    firstQuestion: '1',
    secondQuestion: '1',
    thirdQuestion: '1',
    fourthQuestion: '1',
    subFirstQuestion: '',
    subSecondQuestion: '1',
    subThirdQuestion: '1',
    subFourthQuestion: '1',
    fifthQuestion: '1',
    subFifthQuestion: '1',
    sixthQuestion: '1',
    seventhQuestion: '1',
    subSeventhQuestion: '1',
    eighthQuestion: '1',
    ninethQuestion: '1',
    subNinethQuestion: '1',
    tenthQuestion: '1',
    subTenthQuestion: '1',
    eleventhQuestion: '1',
    twelfthQuestion: '1',
    subTwelfthQuestion: '1'
  },
  beProfessionalAnswers: {
    firstQuestion: '1',
    secondQuestion: '2',
    thirdQuestion: '1',
    fourthQuestion: '4',
    subFirstQuestion: '1',
    subSecondQuestion: '1',
    subThirdQuestion: '2',
    subFourthQuestion: '2',
    fifthQuestion: '1',
    sixthQuestion: '1',
    subSixthQuestion: '1',
    seventhQuestion: '1',
    eighthQuestion: '1',
    subEighthQuestion: '1',
    ninethQuestion: '1',
    subNinethQuestion: '1',
    tenthQuestion: '1',
    subTenthQuestion: '1',
    subFifthQuestion: '1'
  },
  beInclusiveAnswers: {
    firstQuestion: '2',
    subFirstQuestion: '2',
    secondQuestion: '2',
    subSecondQuestion: '',
    thirdQuestion: '2',
    subThirdQuestion: '',
    fourthQuestion: '3',
    subFourthQuestion: '2',
    fifthQuestion: '2',
    subFifthQuestion: '4',
    sixthQuestion: '3',
    subSixthQuestion: '4'
  },
  beYourselfDAnswers: {
    firstQuestion: '1',
    secondQuestion: '1',
    thirdQuestion: '1',
    fourthQuestion: '1',
    subFirstQuestion: '',
    subSecondQuestion: '1',
    subThirdQuestion: '1',
    subFourthQuestion: '',
    fifthQuestion: '1',
    subFifthQuestion: '1'
  },
  beInformedAnswers: {
    firstQuestion: '1',
    secondQuestion: '1',
    thirdQuestion: '1',
    fourthQuestion: '1',
    subFirstQuestion: '1',
    subSecondQuestion: '1',
    subThirdQuestion: '1',
    subFourthQuestion: '1',
    fifthQuestion: '1',
    subFifthQuestion: '1',
    sixthQuestion: '1',
    subSixthQuestion: '1'
  }
};
exports.default = _default;